import React, { Component } from "react";
import moment from "moment";
import { Col, Row, Typography } from "antd";
import titleize from "underscore.string/titleize";

export class ItemCarousel extends Component {

  _handleBoxClick = (item, event) => {
    const { redirect } = this.props;
    return redirect(`/companies/client/edit/${item.id}`)
  };

  _handleCompanyClick = (item, event) => {
    event.stopPropagation();
    const { redirect } = this.props;
    return redirect(`/companies/edit/${item.company_id}`)
  };


  render() {
    const { items } = this.props;
    const colors = {
      approved: "#64b10a",
      "on-boarding": "#64b10a"
    };
    const { Text } = Typography;

    if (items && items.length) {
      return (
        <div className="slider">
          <div className="slider-inner">
            {items.map((item, i) => {
              return (
                <div
                  key={i}
                  className="slide-single"
                  style={{ marginLeft: i === 0 ? 0 : "50px" }}
                  onClick={this._handleBoxClick.bind(this, item)}
                >
                  <Row
                    className="slide-header"
                    align="middle"
                    type="flex"
                    justify="space-between"
                  >
                    <Col style={{ color: colors[item.status] }}>
                      {titleize(item.status)}
                    </Col>
                    <Col>
                      <span>
                        {moment(item.created_at).format("M/D/YYYY")}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className="slide-body"
                      type="flex"
                      align="middle"
                      justify="center">
                      <Row type="flex" justify="start" className="bold">
                        <Text strong={true}>{item.first_name + " " + item.last_name}</Text>
                      </Row>
                      <Row type="flex" justify="start">
                        {item.title}
                      </Row>
                      <Row type="flex" justify="start" >
                        <div className="company-link" onClickCapture={this._handleCompanyClick.bind(this, item)}>
                          {item.company_name} {item.company_status === "pending" ? " (NEW)" : ""}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    return (
      <div className="slider-no-results">
        <span className="bold">No new company User submitted.</span>
      </div>
    );
  }
}

export default ItemCarousel;



// WEBPACK FOOTER //
// ./src/components/dashboard/company/carousel.js